import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AsideHistoryCard } from '../../models/content-vehicle-history-drawer.model';

@Component({
  selector: 'aside-history-card',
  templateUrl: './aside-history-card.component.html',
  styleUrls: ['./aside-history-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsideHistoryCardComponent implements OnInit {
  @Input() data: AsideHistoryCard<'stops'> = {
    id: 0,
    date: '',
    time: '',
    numeration: '',
    duration: '',
    type: 'stops',
    variant: 'stop',
    contentMessage: undefined,
  };
  @Input() isSelected: boolean = false;
  @Output() selectCard = new EventEmitter<{
    id: number;
    type: string;
    variant: string;
    isSelected: boolean;
  }>();

  constructor() {}

  ngOnInit(): void {}

  getVariantLabel(card: AsideHistoryCard): string {
    if (card.type === 'stops') {
      switch (card.variant) {
        case 'stop':
          return 'Parada';
        case 'movement':
          return 'Movimiento';
        case 'start':
          return 'Inicio';
        case 'end':
          return 'Fin';
      }
    }
    if (card.type === 'frames') {
      switch (card.variant) {
        case 'default':
          return 'Trama';
        case 'v1':
          return 'Trama';
      }
    }
    if (card.type === 'events') {
      switch (card.variant) {
        case 'event':
          return 'Evento';
      }
    }
    return String(card.variant || 'Desconocido');
  }

  handleSelectCard(event: Event) {
    event.stopPropagation();
    this.selectCard.emit({
      id: this.data.id,
      type: this.data.type,
      variant: this.data.variant,
      isSelected: this.isSelected,
    });
  }

  isTypeFrame(card: AsideHistoryCard): boolean {
    return card.type === 'frames';
  }

  isTypeStops(card: AsideHistoryCard): boolean {
    return card.type === 'stops';
  }
}
